import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import qs from "qs";

const asIs = (arg) => arg;

const useParam = (key, defaultValue, parse = asIs) => {
	const { search } = useLocation();
	const params = useMemo(() => {
		return qs.parse(search, {
			ignoreQueryPrefix: true,
		});
	}, [search]);
	return useMemo(
		() => (params[key] ? parse(params[key]) : defaultValue),
		[params[key]]
	);
};

export default useParam;
